export default ({ data }) => {
  let {
    label,
    recommend1,
    recommend2,
    recommend3,
    recommend4,
    template,
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
  } = data;

  if (template) {
    template = template
      .replace("{{label}}", label)
      .replace("{{recommend1}}", recommend1)
      .replace("{{recommend2}}", recommend2)
      .replace("{{recommend3}}", recommend3)
      .replace("{{recommend4}}", recommend4);
  }

  return (
    <div>
      {!!template ? (
        <section
          style={{
            paddingTop,
            paddingBottom,
            paddingRight,
            paddingLeft,
          }}
          dangerouslySetInnerHTML={{ __html: template }}
        ></section>
      ) : (
        <div>Default WeChat QR Code Block</div>
      )}
    </div>
  );
};
